import baseAPI from '@/api/base';
import {
  EditYurtzeitenTemplate,
  GetYurtzeitenTemplate,
  RegisterYurtzeitenTemplate,
} from '@/dtos/yurtzeiten_template.dto';
import {
  DELETE_YURTZEITEN_TEMPLATE_URL,
  EDIT_YURTZEITEN_TEMPLATE_URL,
  GET_YURTZEITEN_TEMPLATE_URL,
  REGISTER_YURTZEITEN_TEMPLATE_URL,
  TOGGLE_YURTZEITEN_TEMPLATE_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class YurtzeitenTemplate {
  static getYurtzeitenTemplates = async (
    getYurtzeitenTemplate: GetYurtzeitenTemplate
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_YURTZEITEN_TEMPLATE_URL, {
      params: getYurtzeitenTemplate,
    });
    console.log('response', response);
    return response;
  };

  static registerYurtzeitenTemplate = async (
    registerYurtzeitenTemplate: RegisterYurtzeitenTemplate
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_YURTZEITEN_TEMPLATE_URL,
      {
        ...registerYurtzeitenTemplate,
      }
    );
    console.log('response', response);
    return response;
  };

  static editYurtzeitenTemplate = async (
    editYurtzeitenTemplate: EditYurtzeitenTemplate
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_YURTZEITEN_TEMPLATE_URL,
      {
        ...editYurtzeitenTemplate,
      }
    );
    return response;
  };

  static toggleYurtzeitenTemplateIsActive = async (
    editYurtzeitenTemplate: EditYurtzeitenTemplate
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_YURTZEITEN_TEMPLATE_IS_ACTIVE_URL,
      {
        ...editYurtzeitenTemplate,
      }
    );
    return response;
  };

  static deleteYurtzeitenTemplate = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_YURTZEITEN_TEMPLATE_URL}/${id}`
    );
    return response;
  };
}

export default YurtzeitenTemplate;

